import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "ALLMX - Accessori e Ricambi Motocross Premium | Shop Online",
  description = "Scopri oltre 300 prodotti premium per motocross su ALLMX.it: plastiche, freni, sospensioni, lubrificanti e accessori delle migliori marche. Spedizione veloce dall'Italia.",
  keywords = "motocross, ricambi moto, accessori motocross, plastiche moto, freni moto, sospensioni, lubrificanti moto, KTM, Husqvarna, GasGas, Honda, Yamaha, ALLMX",
  image = "https://allmx.it/og-image.jpg",
  url = "https://allmx.it",
  type = "website",
  // Product-specific Open Graph tags
  productPrice,         // number, e.g. 119.00
  productCurrency = "EUR",
  productAvailability,  // "in stock" | "out of stock" | "preorder"
  productBrand,
  productCategory,
  productSku,
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook / WhatsApp / LinkedIn */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:secure_url" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} />
      <meta property="og:site_name" content="ALLMX" />
      <meta property="og:locale" content="it_IT" />

      {/* Product-specific Open Graph (Facebook product schema) */}
      {type === 'product' && productPrice != null && (
        <meta property="product:price:amount" content={productPrice.toFixed(2)} />
      )}
      {type === 'product' && (
        <meta property="product:price:currency" content={productCurrency} />
      )}
      {type === 'product' && productAvailability && (
        <meta property="product:availability" content={productAvailability} />
      )}
      {type === 'product' && productBrand && (
        <meta property="product:brand" content={productBrand} />
      )}
      {type === 'product' && productCategory && (
        <meta property="product:category" content={productCategory} />
      )}
      {type === 'product' && productSku && (
        <meta property="product:retailer_item_id" content={productSku} />
      )}
      {/* Legacy og:price tags (some scrapers prefer these) */}
      {type === 'product' && productPrice != null && (
        <meta property="og:price:amount" content={productPrice.toFixed(2)} />
      )}
      {type === 'product' && (
        <meta property="og:price:currency" content={productCurrency} />
      )}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={title} />
      {type === 'product' && productPrice != null && (
        <meta name="twitter:label1" content="Prezzo" />
      )}
      {type === 'product' && productPrice != null && (
        <meta name="twitter:data1" content={`€${productPrice.toFixed(2)}`} />
      )}
      {type === 'product' && productAvailability && (
        <meta name="twitter:label2" content="Disponibilità" />
      )}
      {type === 'product' && productAvailability && (
        <meta name="twitter:data2" content={productAvailability === 'in stock' ? 'Disponibile' : productAvailability === 'preorder' ? 'Pre-ordine' : 'Esaurito'} />
      )}

      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;
